import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BehanceOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "behance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.52 11.78a1.4 1.4 0 001.12-1.43c0-1-.77-1.6-1.94-1.6H7v6.5h2.7c1.3-.05 2.3-.72 2.3-1.88a1.52 1.52 0 00-1.48-1.59zM8.26 9.67h1.15c.6 0 .95.32.95.85s-.38.89-1.25.89h-.85zm1 4.57h-1V12.3h1.23c.75 0 1.17.38 1.17 1s-.42.94-1.44.94zM14.75 10.3a2.11 2.11 0 00-2.28 2.25V13a2.15 2.15 0 002.34 2.31A2 2 0 0017 13.75h-1.21a.9.9 0 01-1 .63 1.07 1.07 0 01-1.09-1.19v-.14H17v-.47a2.12 2.12 0 00-2.25-2.28zm1 2h-2.02a1 1 0 011-1.09 1 1 0 011 1.09z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: .5,
    x: 13.25,
    y: 9.2
  }))));
});
BehanceOutline.displayName = 'BehanceOutline';
export var BehanceOutlineDimensions = {
  height: 24,
  width: 24
};